import styled from 'styled-components'

const ModulesStyled = styled.div`
  /* Título y filtros (fechas) en una fila, como en las estadísticas de talent; sin el margen
     superior de 38 px (el padding lo da la página) */
  .title-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 0 0 24px;

    > .MuiGrid-item {
      flex: 0 1 auto;
      max-width: none;
    }

    .title {
      align-items: center;
      display: flex;
    }
  }

  .modules-wrapper {
    padding: 50px 0;
  }

  .buttons-wrapper {
    text-align: right;
  }
`

export default ModulesStyled
